import { FunctionComponent } from "react";
import {
  Typography,
  TableContainer,
  Table,
  TableHead,
  TableBody,
  TableRow,
  Paper,
  Tooltip,
} from "@mui/material";

import { Cell, HeadCell } from "..";
import { dateToHHMM } from "../../utils"

type Props = {
  waypoints: Waypoint[];
  onClick: (id: string) => any;
};

export const WaypointsTable: FunctionComponent<Props> = ({
  waypoints,
  onClick,
}) => {
  if (!waypoints?.length) return null;

  return (
    <>
      <Typography
        variant="h5"
        sx={{ paddingTop: "16px", paddingBottom: "13px" }}
      >
        Waypoints:
      </Typography>
      <TableContainer component={Paper}>
        <Table aria-label="waypoints table">
          <TableHead>
            <TableRow>
              <HeadCell>Waypoint</HeadCell>
              <HeadCell>ETO</HeadCell>
              <HeadCell>ATO</HeadCell>
              <Tooltip placement="top-start" title="Min Fuel">
                <HeadCell>MFQ</HeadCell>
              </Tooltip>
              <Tooltip placement="top-start" title="Fuel On Board">
                <HeadCell>AFQ</HeadCell>
              </Tooltip>
              <Tooltip placement="top-start" title="Planned Fuel">
                <HeadCell>EFQ</HeadCell>
              </Tooltip>
              <Tooltip placement="top-start" title="Fuel On Board - Min Fuel">
                <HeadCell>AFQ&nbsp;-&nbsp;MFQ</HeadCell>
              </Tooltip>
              <Tooltip
                placement="top-start"
                title="Fuel On Board - Planned Fuel"
              >
                <HeadCell>AFQ&nbsp;-&nbsp;EFQ</HeadCell>
              </Tooltip>
            </TableRow>
          </TableHead>
          <TableBody>
            {waypoints.map((row: Waypoint) => (
              <TableRow key={row.id}>
                <Cell
                  component="th"
                  scope="row"
                  onClick={() => onClick(row.id)}
                  sx={{ cursor: "pointer" }}
                >
                  {row.waypointName}
                </Cell>
                <Cell>{dateToHHMM(row.ETO)}</Cell>
                <Cell>{row.isAtoSet && row.ATO ? dateToHHMM(row.ATO) : "-"}</Cell>
                <Cell>{row.MFQ}</Cell>
                <Cell>{row.AFQ || "-"}</Cell>
                <Cell>{row.EFQ}</Cell>
                {row.AFQ ? (
                  <>
                    <Cell
                      sx={{
                        backgroundColor:
                          row.AFQ - row.MFQ > 0 ? "#00ff0029" : "#ff000029",
                      }}
                    >
                      {row.AFQ - row.MFQ}
                    </Cell>
                    <Cell
                      sx={{
                        backgroundColor:
                          row.AFQ - row.EFQ > 0 ? "#00ff0029" : "#ff000029",
                      }}
                    >
                      {row.AFQ - row.EFQ}
                    </Cell>
                  </>
                ) : (
                  <>
                    <Cell>-</Cell>
                    <Cell>-</Cell>
                  </>
                )}
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </TableContainer>
    </>
  );
};
